// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 746 ? "pages-" : chunkId) + "." + {"96":"b4cc2fea","400":"071bba13","746":"f7c84816"}[chunkId] + ".chunk.js";
};